interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const AddIcon = ({ iconColor = '#212529', width = '18', height = '18' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.03647 10.9602C10.4033 12.327 12.6194 12.327 13.9862 10.9602L17.5217 7.42462C18.8886 6.05779 18.8886 3.84171 17.5217 2.47487C16.1549 1.10804 13.9388 1.10804 12.572 2.47487L10.8042 4.24264"
			stroke="#868E96"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<path
			d="M11.8698 8.13164C10.5029 6.76481 8.28687 6.76481 6.92004 8.13164L3.3845 11.6672C2.01767 13.034 2.01767 15.2501 3.3845 16.6169C4.75134 17.9838 6.96741 17.9838 8.33425 16.6169L10.102 14.8492"
			stroke="#868E96"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

export default AddIcon;
